import { render, staticRenderFns } from "./CustomizedDiagramPieceSetting.vue?vue&type=template&id=1ce78de8&scoped=true&"
import script from "./CustomizedDiagramPieceSetting.vue?vue&type=script&lang=js&"
export * from "./CustomizedDiagramPieceSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce78de8",
  null
  
)

export default component.exports